import { isValidDate, diffdays } from '../utils/Validate';
import ValidateField from '../hooks/useValid';
import { ValidateMessages } from '../constants/ValidateConstants';
import { ValidateName } from '../constants/ValidateNameConstants';

export default function ValidateProject(values, projectList) {
    let projectcheck;
    if (!values?.id)
        projectcheck = projectList?.find((obj) => obj?.countryId == values?.countryId && obj?.projectName == values.projectName);
    else
        projectcheck = projectList?.find((obj) => obj?.countryId == values?.countryId && obj?.projectName == values.projectName && obj?.id !== values?.id);
    let errors = {};

    errors.projectName = ValidateField(
        values.projectName,
        ValidateName?.PROJECT_NAME,
        ValidateName?.PROJECT_NAME,
        [ValidateName?.REQUIRED, ValidateName?.MIN_LENGTH],
    );

    errors.projectSegmentId = ValidateField(
        values.projectSegmentId,
        ValidateName?.PROJECT_SEGMENT,
        ValidateName?.PROJECT_SEGMENT,
        [ValidateName?.REQUIRED],
    );

    errors.projectStatusId = ValidateField(
        values.projectStatusId,
        ValidateName?.PROJECT_STATUS,
        ValidateName?.PROJECT_STATUS,
        [ValidateName?.REQUIRED],
    );


    errors.distributorId = ValidateField(
        values.distributorId,
        ValidateName?.DISTRIBUTOR,
        ValidateName?.DISTRIBUTOR,
        [ValidateName?.REQUIRED],
    );

    errors.mainContractorId = ValidateField(
        values.mainContractorId,
        ValidateName?.MAIN_CONTRACTOR,
        ValidateName?.MAIN_CONTRACTOR,
        [ValidateName?.REQUIRED],
    );

    errors.countryId = ValidateField(
        values.countryId,
        ValidateName?.COUNTRY,
        ValidateName?.COUNTRY,
        [ValidateName?.REQUIRED],
    );

    errors.endDate = ValidateField(
        values.endDate,
        ValidateName?.END_DATE,
        ValidateName?.END_DATE,
        [ValidateName?.REQUIRED],
    );

    if (projectcheck) { errors.projecterr = ValidateMessages?.SHOULD_SAME_FIELD_NAME("project") }

    if (isValidDate(values.endDate) && isValidDate(values.startDate)) {
        if (diffdays(values.startDate, values.endDate) < 0) {
            errors.endDate = ValidateMessages?.GREATER_START_DATE;
        }
    }

    let error = {}
    Object.keys(errors).map((key, index) => {
        if (errors[key] !== undefined)
            error[key] = errors[key]
    })
    return error;
}


